<template>
  <g-master name="job_assets"
            @params="paramsTable"
            :endpoint="jbMaster.endpoint"
            :tableSetup="jbMaster.tableSetup"
            :modalFieldsSetup="jbMaster.modalFieldsSetup"
            :parentData="jbParentData"
            :beforeSend="jbMaster.beforeSend">
    <template slot="customButton">
      <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <g-dropdown endpoint="hierarchy_lookup"
                  label="Elemento"
                  :formItemConfig="fiOptions"
                  :decorator="['id_h_asset', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  :params="id_h_asset_param">
      </g-dropdown>
    </template>
  </g-master>
</template>
<script>
  export default {
    data () {
      return {
        id_h_asset_param: {
          h_lookup_type: 'LOGISTICA_CARGO'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 12},
          'has-feedback': true
        },
        jbMaster: {
          endpoint: 'job_assets',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Cargo', dataIndex: 'job_name', sorter: true},
              {title: 'Elemento', dataIndex: 'h_asset', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_asset'}
          ],
          beforeSend: (data) => {
            data.id_job = this.jobId
            return data
          }
        },
        endpointExcel: 'job_assets_/downloadExcel',
        fileNameExcel: 'LogisticaDelCargo',
        paramsT: {}
      }
    },
    props: ['jobId'],
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      jbParentData () {
        return {
          id_job: this.jobId
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.jbMaster.tableSetup.columns, ...this.jbParentData}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Jobs/JobsAssets.vue